import './App.css';
import BlogPage from './components/BlogPage';
import Skill from './components/Skill';
import Connect from './components/Connect'; 
import React from 'react';
import Headercomponents from './components/Headercomponents';
import Homepage from './components/Homepage';
import {HashRouter as Router, Route, Routes, useLocation} from "react-router-dom";
import Research from './components/Research';
import Publication from './components/Publication';
import ScrollToTop from './components/ScrollToTop';
import { AnimatePresence } from 'framer-motion';

// AnimatePresenceにはuseLocationが必要なので内部コンポーネントに分離
function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/"element={<Homepage />}/>
        <Route path="/Research"element={<Research />}/>
        <Route path="/Publication"element={<Publication />}/>
        <Route path="/Product"element={<BlogPage />}/>
        <Route path='/skills'element={<Skill />}/>
        <Route path="/Connect"element={<Connect />}/>
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
<Router>
  <div className="App">
    <ScrollToTop />
    <Headercomponents />
    <AnimatedRoutes />
  </div>
</Router>
  );
}

export default App;
